// File Metadata:
// Filename: DashFooter.js
// Version: 1.00
// Created: 2022-10-02 00:45:47
// Last Modified: 2025-04-01 16:55:19
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse, faRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import { useNavigate, useLocation } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
import { useSendLogoutMutation } from '../features/api/authApiSlice'
import { useEffect } from 'react'

const DashFooter = () => {
	const { username, roles } = useAuth()
	console.log('DashFooter - Current roles:', roles)
	const navigate = useNavigate()
	const { pathname } = useLocation()

	const [sendLogout, { isLoading, isSuccess, isError, error }] = useSendLogoutMutation()

	useEffect(() => {
		if (isSuccess) navigate('/')
	}, [isSuccess, navigate])

	const onGoHomeClicked = () => navigate('/dash')

	let goHomeButton = null
	if (pathname !== '/dash') {
		goHomeButton = (
			<button className='icon-button' title='Home' onClick={onGoHomeClicked}>
				<FontAwesomeIcon icon={faHouse} />
			</button>
		)
	}

	let logoutButton = null
	if (username) {
		logoutButton = (
			<button className='icon-button' title='Logout' onClick={sendLogout}>
				<FontAwesomeIcon icon={faRightFromBracket} />
			</button>
		)
	}

	const content = (
		<footer className='dash-footer'>
			{goHomeButton}
			{logoutButton}
			<p>Current User: {username}</p>
			<p>Status: {}</p>
		</footer>
	)
	return content
}
export default DashFooter
